import { useQuery } from '@tanstack/react-query';
import { allocationQueries } from '../queries';

/** Perfis de venda ativos do contrato do projeto escolhido; parado enquanto não há projeto. */
export function useSalesProfiles(contractId: number | undefined) {
  return useQuery(allocationQueries.salesProfiles(contractId));
}
